export const Header = (props) => {
  return (
    <header id='header'>
      <div className='intro'>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              {/* <div className='col-md-8 col-md-offset-2 intro-text'> */}
              <div className='col-md-6 intro-text'>
                <h1>
                  {props.data ? props.data.title : 'Loading'}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : 'Loading'}</p>
                <a
                  href='#kontakt'
                  className='btn btn-custom btn-lg page-scroll'
                >
                  {props.data ? props.data.button : 'Loading'}
                </a>{' '}
              </div>
              <div className='col-md-3 intro-img-one'>
                <img className="img-responsive animate__animated animate__fadeInRight" src={props.data ? props.data.img_one : 'Loading'} alt="" />
              </div>
              <div className='col-md-3 intro-img-two'>
                <img className="animate__animated animate__fadeInRight animate__delay-1s" src={props.data ? props.data.img_two : 'Loading'} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
